// components/EmptyState.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ primaryMessage, secondaryMessage, buttonTitle, redirectUrl }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flex='1'
      flexDirection="column"
      gap={2}
      width='100%'
    >
      <Typography variant="h7" color="text.primary">
        {primaryMessage}
      </Typography>
      <Typography variant="body1" color="text.primary" sx={{ textAlign: 'center' }}>
        {secondaryMessage}
      </Typography>
      {buttonTitle && redirectUrl && (
        <Button variant="contained" color="primary" size="medium" onClick={handleButtonClick}>
          {buttonTitle}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;

//  <EmptyState
//   primaryMessage='No posts, yet. '
//   secondaryMessage='You will see a record of your posts here.'
//   buttonTitle='Create Post on Ask'
//   redirectUrl='/ask'
// />

// <EmptyState
//   primaryMessage='No replies, yet. '
//   secondaryMessage={
//     <>
//       You will see a record of your replies here.
//       <br />
//       Go view some posts to reply to!
//     </>
//   }
//   buttonTitle='View Posts on Ask'
//   redirectUrl='/ask'
// />

//  <Box
//       display='flex'
//       flexDirection='column'
//       flex='1'
//       width='100%'
//       height='100%'
//     >
//       <Box
//         sx={{
//           py: { xs: 3, md: 4 },
//           width: '100%',
//           height: '100%',
//           display: 'flex',
//           flexDirection: 'column',
//         }}
//       ></Box>